export enum ReferralStatus {
  SIGNED_UP = 'signed_up',
  PREMIUM = 'premium',
  REWARD_ELIGIBLE = 'reward_eligible',
  REWARD_SENT = 'reward_sent'
}

export interface IReferral {
  referrerBid: string; // Who made the referral
  referredBid: string; // Who was referred
  referralCode: string; // The unique referral code used
  status: ReferralStatus;
  premiumStartDate?: Date; // When referred user became premium
  rewardEligibleDate?: Date; // When they became eligible (1 month premium)
  rewardSentDate?: Date; // When gift card was sent
  giftCardCode?: string; // Buyme gift card code
  createdAt?: Date | string;
}

export interface IReferralItem {
  id: string;
  referredBusinessName: string;
  status: ReferralStatus;
  signupDate: Date | string;
  premiumDate?: Date;
  rewardEligibleDate?: Date;
}
